import { ReferenceOption, UpdateApproachReference } from './types';

const updateApproachReference: UpdateApproachReference = ({
  approaches,
  column,
  lookup,
  specificApproachKey,
  updateKey,
  referenceKey,
  extraOptions = [],
}) => {
  const tmpColumn = column;
  // options = full approaches (have valuations_approach_gpc, panelId) + extraOptions (only id, name).
  // When matching, extraOptions have no specificApproachKey so we must use optional chaining.
  const options = [...approaches, ...extraOptions] as ReferenceOption[];
  const selectedOption = options.find(
    option =>
      option.panelId === lookup ||
      option[specificApproachKey]?.id?.toString() === lookup.toString() ||
      option.id === Number(lookup)
  );
  // if the approach has been saved, grab the id of the gpc approach,
  // else set it to null if no approach is found or the approach is not saved
  const resolvedId = selectedOption?.[specificApproachKey]?.id;
  if (resolvedId !== undefined && resolvedId !== null) {
    tmpColumn[updateKey] = resolvedId;
  } else if (selectedOption?.id === 0) {
    tmpColumn[updateKey] = null;
  } else {
    tmpColumn[updateKey] = null;
  }
  // always set the reference. Can be null if no approach was found
  tmpColumn[referenceKey] = selectedOption?.panelId ?? null;
};
export default updateApproachReference;
